import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Usuario } from './usuario';
import { UsuarioService } from 'src/app/service/usuario.service';
import { Perfil } from 'src/app/model/perfil';
import { PerfilService } from 'src/app/service/perfil.service';
import { Utils } from 'src/app/util/utils';

@Component({
  selector: 'app-usuario-form',
  templateUrl: './usuario-form.component.html',
  styleUrls: ['./usuario.component.scss'],
})
export class UsuarioFormComponent implements OnInit {

  formulario: FormGroup;
  hide = true;
  mensagemErros: String[] = [];
  perfis: Perfil[] = [];
  compararCampos = this.utils.compararCampos;
  carregando = false;

  constructor(
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    private usuarioService: UsuarioService,
    private perfilService: PerfilService,
    private utils: Utils,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.consultarPerfil();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      username: [null, Validators.nullValidator],
      password: [null, Validators.nullValidator],
      name: [null, Validators.nullValidator],
      ativo: [true, Validators.nullValidator],
      perfil: [null, Validators.nullValidator],
    });
  }

  submit() {
    const formValues = this.formulario.value;
    const client: Usuario = new Usuario(
      formValues.id,
      formValues.username,
      formValues.password,
      formValues.name,
      formValues.ativo,
      formValues.perfil,
    );

    if (formValues.id) {
      this.usuarioService.update(client).subscribe(() => {
        this.snackBar.open('Produto alterado com sucesso!', 'Sucesso', {
          duration: 2000,
        });
        this.voltarConsulta();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000,
        });
      });
    } else {
      this.usuarioService.save(client).subscribe(() => {
        this.snackBar.open('Cliente salvo com sucesso!', 'Sucesso', {
          duration: 2000,
        });
        this.voltarConsulta();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000,
        });
      });
    }
  }

  carregar(id: number) {
    this.carregando = true;
    this.usuarioService.getById(id).subscribe((response) => {
      this.formulario.controls['id'].setValue(response.id);
      this.formulario.controls['username'].setValue(response.username);
      this.formulario.controls['password'].setValue(response.password);
      this.formulario.controls['name'].setValue(response.name);
      this.formulario.controls['ativo'].setValue(response.ativo);
      this.formulario.controls['perfil'].setValue(response.perfil);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Usuário não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  consultarPerfil() {
    this.perfilService.buscarPerfisAtivo().subscribe((response) => {
      this.perfis = response;
    });
  }

  limpar() {
    this.router.navigate(['/usuario/form']);
    this.montarFormulario();
  }

  voltarConsulta() {
    this.router.navigate(['/usuario/consulta']);
  }
}
